import { Link } from "react-router-dom";
import { Swords, Crown } from "lucide-react";
import { UserAvatar } from "@/components/UserBits";

function Side({ s, won }) {
  return (
    <div className={`flex-1 min-w-0 text-center rounded-2xl p-3 ${won ? "bg-amber-400/20 ring-1 ring-amber-300/60" : "bg-white/5"}`}>
      <div className="relative inline-block">
        <UserAvatar userId={s.user_id} name={s.name} picture={s.picture} size="w-14 h-14" text="text-lg" />
        {won && <Crown className="absolute -top-3 left-1/2 -translate-x-1/2 w-6 h-6 text-amber-300 fill-amber-400" />}
      </div>
      <p className="mt-1 text-sm font-extrabold truncate">{s.name}</p>
      <p className="text-xs text-white/60">{s.tries} {s.tries === 1 ? "Versuch" : "Versuche"}{s.cracked ? " · geknackt" : ""}</p>
    </div>
  );
}

export function VaultDuelPost({ v }) {
  return (
    <div className="mx-4 mb-3 rounded-3xl bg-slate-950 text-white p-4 space-y-3 ring-1 ring-rose-400/30" data-testid={`vault-duel-post-${v.id}`}>
      <p className="text-[11px] font-extrabold uppercase tracking-[0.2em] text-rose-300 flex items-center gap-1.5"><Swords className="w-4 h-4" /> Tresor-Duell · {v.stake} Punkte Einsatz</p>
      <div className="flex items-stretch gap-2">
        <Side s={v.a} won={v.winner === "a"} />
        <span className="self-center font-display text-lg font-black text-rose-300">VS</span>
        <Side s={v.b} won={v.winner === "b"} />
      </div>
      <p className="text-center text-xs text-white/50">Code: <b className="tracking-[0.3em] text-amber-200">{v.code}</b>{v.cheers ? ` · ${v.cheers}× angefeuert` : ""}</p>
      <Link to="/spiele/tresor" data-testid={`vault-duel-post-cta-${v.id}`} className="flex h-10 rounded-full bg-gradient-to-r from-rose-500 to-amber-500 font-extrabold text-sm items-center justify-center gap-2"><Swords className="w-4 h-4" /> Selbst ein Duell starten</Link>
    </div>
  );
}
